<template>
    <div>
        <div class="selistContent" v-if="list.length > 0">
            <div class="commonItem flx alc" v-for="item,index in list" v-if="type != 3 & type != 7" @click="toDetail(item)">
                <div class="itmImage">
                    <img v-if="item.pc_avatar" :src="$img(item.pc_avatar)" alt="" />
                    <img v-else :src="$img(item.avatar)" alt="" />
                </div>
                <div class="itemInfo">
                    <div class="itemName" v-html="setRedText(item.name, keyword)">

                    </div>
                    <div class="itemTitle" v-text="item.title">

                    </div>
                </div>
            </div>
        </div>
        <div v-else style="box-sizing: border-box;padding-top: 100rpx;">
            <img :src="$Localimg('nosearch.png')" class="nodatas" alt="">
        </div>
    </div>

</template>

<script>
    export default {
        name: "acsearch",
        props: {
            type: String,
            list: Array,
            keyword: String
        },
        data() {
            return {};
        },
        created() {
            let that = this
        },
        methods: {
            setRedText(text, key) {
                if (!key) return text;
                // 正则g全局匹配，忽略大小写加i
                const reg = new RegExp(key, "g");
                // 替换为红色span标签
                return text.replace(reg, `<span style="color:red">${key}</span>`);
            },
            toDetail(e) {
                let that = this
                console.log(e)
                if (that.type == 1) {
                    this.$router.push({
                        path: '/signDetail', // 写路由path
                        query: {
                            id: e.id
                        }
                    })
                } else if (that.type == '2-1') {
                    this.$router.push({
                        path: '/liveDetail', // 写路由path
                        query: {
                            id: e.id,
                            type:1
                        }
                    })
                } else if (that.type == '2-2') {
                    this.$router.push({
                        path: '/liveDetail', // 写路由path
                        query: {
                            id: e.id,
                            type:2
                        }
                    })
                }else if (that.type == 4) {
                    this.$router.push({
                        path: '/coachDetail', // 写路由path
                        query: {
                            id: e.id
                        }
                    })
                } else if (that.type == 5) {
                    this.$router.push({
                        path: '/cerDetail', // 写路由path
                        query: {
                            id: e.id
                        }
                    })
                } else if (that.type == 6) {
                    this.$router.push({
                        path: '/eduDetail', // 写路由path
                        query: {
                            id: e.id
                        }
                    })
                } else if (that.type == 9) {
                    this.$router.push({
                        path: '/serviceDetail', // 写路由path
                        query: {
                            id: e.id
                        }
                    })
                }
            },
        }
    };
</script>

<style scoped>
    .commonItem {
        padding: 30px;
        border-bottom: 1px solid #eaeaea;
    }

    .itemInfo {
        text-align: left;
    }

    .itemName {
        font-weight: 600;
        font-size: 16px;
        color: #000000;
        margin-bottom: 8px;
    }

    .itemTitle {
        font-weight: 500;
        font-size: 14px;
        color: #9CA3AF;
    }

    .itmImage {
        width: 128px;
        height: 72px;
        margin-right: 12px;
    }

    .itmImage img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 6px;
    }
</style>